import { createApp } from "vue";
import { ModalHelper } from "../B2bTools";
import MiniFormulaire from "../MiniFormulaire";
import Store from "../Store";
import { toPrix } from "./composant/b2bLangue";
// Chart.js
import {
    ArcElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    Title,
    Tooltip,
} from "chart.js";
import { Doughnut } from "vue-chartjs";

import { Offcanvas } from "bootstrap";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

import orderManagerCartForm from "./orderManagerCart";
import orderManagerCreateForm from "./orderManagerCreate";
import orderManagerDuplicateForm from "./orderManagerDuplicate";


import orderManagerHtml from "./orderManager.html";

import orderManagerSelectorderHtml from "./orderManagerSelectorder.html";

import orderChart from "./orderChart.html";

const CONTEXTE = {};

const orderManagerMf = {
    url: function (echangeur) {
        
        /*!! 
                @Dev 
                MB : 08/01/2024 (40ans...) 🎂🥳🎈
                MB : 14/01/2025 (41ans...) 🎂🥳🎈
                    il faut trouver un moyen de passer l'environement 
                    on ne récupère pas le hash avec echangeur.hash
            */
        // console.log(window.location.hash);

        // https://lbt.acs2i.fr/dmkv2/#env&u=collection/linelist&_id=6352a5b98ee6451760bff749&env=collection/productSaisie&reference=1140114_BK01&linelist=6352a5b98ee6451760bff749

        // let hs = window.location.hash.split("/");
        // let h = null;

        // for (let hh of hs) if (hh.indexOf("&u=") > -1) h = hh.split("&u=")[1];


        
        let hs = (window.location.hash).split("/");
        let h = null;
        for (let hh of hs){
            //#orderVerifie&u=collection&env=collection&_ids=6644b1f1aeed35141829781e&ecran=delete
            if (!h && hh.indexOf('&u=') > -1) {
                let   tt = hh.split('&');
                let   t  = tt.find(u=>u.indexOf("u=")>-1);
                if(t) h  = t.split('u=')[1];
            }
        } 


        echangeur.addAction("b2b.cart.list", { env: h }, "", "data"); 
    },
    onLoad : async function(echangeur) {
        const OFFCANVAS_CART = "#offcanvasCart";
        let offcanvas = new Offcanvas(OFFCANVAS_CART, {});
        const miniFormulaireCart = new MiniFormulaire("cart");
        miniFormulaireCart.initialise(OFFCANVAS_CART);
        miniFormulaireCart.fillImport(orderManagerCartForm);

        miniFormulaireCart.objectConteneur = offcanvas;

        let listOrders = echangeur.data.rows;
        let env = echangeur.data.env;
        //
        // initialisation du cart //
        miniFormulaireCart.demarre({ _id: "" });

        let THIS = this;

        THIS.onError = function (etat, message, p) {
            window.alert(message || p);
        };
        const app = createApp({
            data: function () {
                return {
                    currentOrder: listOrders.length == 1 ? listOrders[0] : null,
                    listOrders,
                };
            },
            methods: {
                updateTotaux(order) {
                    if (this.currentOrder && this.currentOrder._id == order._id) {
                        this.currentOrder.totaux = order.totaux;
                        this.currentOrder.rows = order.rows;
                    }
                },

                showCart() {
                    // if (this.currentOrder) offcanvas.show();
                    offcanvas.show();
                },

                toPrix(value, devise) {
                    return toPrix(value, devise);
                },

                /** Actualise la liste des commandes */
                async getOrderlist(echangeur) {
                    let p = { _id: "" };
                    // if(echangeur && echangeur.hash && echangeur.hash.env ) p.env = echangeur.hash.env

                    console.log("getOrderlist ", env);
                    const a = await THIS.rest("b2b.cart.list", { env: env });
                    this.listOrders = a.rows;
                    return a.rows;
                },

                async changeOrder(_id) {
                    const a = this.listOrders.find((order) => order._id == _id);
                    if (a) {
                        this.currentOrder = await THIS.rest("b2b.cart.get", { _id: _id });
                    }
                },

                getData() {
                    return this.$data;
                },

                async getCurrentOrder() {
                     if (!this.currentOrder) return null;
                    const cart = await THIS.rest("b2b.cart.get", {
                        _id: this.currentOrder._id,
                    });
                    return cart;
                },

                async setCurrentOrder(_id) {
                    const cart = await THIS.rest("b2b.cart.get", { _id: _id });
                    this.currentOrder = cart;
                    return cart;
                },

                async "b2b.cart.get"(_id) {
                    const cart = await THIS.rest("b2b.cart.get", { _id: _id });
                    this.currentOrder = cart;
                    return cart;
                },
                duplicateOrder(callback, idSource) {
                    /* console.log("creataordercallback", callback) */
                    const thisParent = this;

                    const miniFormulaire = new MiniFormulaire("duplicateOrder");
                    miniFormulaire.initialise(ModalHelper.getConteneur());
                    ModalHelper.html(orderManagerDuplicateForm.html);
                    for (var a in orderManagerDuplicateForm.js)
                        miniFormulaire[a] = orderManagerDuplicateForm.js[a];
                    //
                    ModalHelper.show(async function () {
                        /* console.log("createOrder onHide") */
                    });
                    //
                    const onSuccess = async function (echangeur) {
                        //
                        await thisParent.getOrderlist(echangeur);
                        //
                        thisParent.changeOrder(echangeur.result._id);
                        ModalHelper.hide();
                        //
                        if (callback) callback(echangeur.result._id);
                    };
                    miniFormulaire.demarre(idSource, onSuccess);
                    //
                },
                createOrder(callback,edi) {
                    
                    /* console.log("creataordercallback", callback) */
                    const thisParent = this;

                    const miniFormulaire = new MiniFormulaire("createOrder");
                    miniFormulaire.initialise(ModalHelper.getConteneur());
                    ModalHelper.html(orderManagerCreateForm.html);
                    for (var a in orderManagerCreateForm.js) miniFormulaire[a] = orderManagerCreateForm.js[a];

                    if(edi) miniFormulaire['isEdi'] = true

                    //
                    ModalHelper.show(async function () {
                        /* console.log("createOrder onHide") */
                    });
                    //
                    const onSuccess = async function (echangeur) {
                        //
                        await thisParent.getOrderlist(echangeur);
                        //
                        thisParent.changeOrder(echangeur.result._id);
                        ModalHelper.hide();
                        //
                        if (callback) callback(echangeur.result._id);
                    };
                    miniFormulaire.demarre("", onSuccess);
                    //
                },

                lanceSelectOrder(callback, forceCreate) {
                     
                    if (!this.listOrders.length || forceCreate) {
                        return this.createOrder(callback);
                    } else {
                        let listOrders = [...this.listOrders];
                        const thisParent = this;
                        const modaleApp = createApp({
                            data: () => ({
                                listOrders: listOrders,
                                idSelected: null,
                                lanceCreateorder: false,
                                _id: null,
                            }),
                            methods: {
                                toPrix(value, devise) {
                                    return toPrix(value, devise);
                                },
                                close() {
                                    ModalHelper.hide();
                                },
                                createOrder() {
                                    this.lanceCreateorder = true;
                                    ModalHelper.hide();
                                },
                                valide(idSelected) {
                                    this._id = idSelected;
                                    ModalHelper.hide();
                                    if (callback) callback(idSelected);
                                },
                            },
                            mounted() {
                                let thisVue = this;
                                ModalHelper.show(function () {
                                    const lanceCreateorder = thisVue.lanceCreateorder;
                                    const _id = thisVue._id;
                                    modaleApp.unmount();
                                    //
                                    if (lanceCreateorder) {
                                        thisParent.createOrder(callback);
                                    } else {
                                        if (_id) thisParent.changeOrder(_id);
                                    }
                                });
                            },
                        });

                        modaleApp.mount(
                            ModalHelper.html(orderManagerSelectorderHtml).container
                        );
                    }
                },

                async orderChart(currentOrder) {
                    if (!currentOrder) return;

                    const result = await THIS.rest("b2b.orders.stats", {
                        _ids: [currentOrder._id],
                    });
                    if (result.isEmpty) {
                         return; 
                    } 
 
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                tableaux: [
                                    construitTableau(result.stats.collectiontype, {
                                        caption: "Collection type",
                                    }),
                                    construitTableau(result.stats.deliverytheme, {
                                        caption: "Delivery Theme",
                                    }),
                                    construitTableau(result.stats.department, {
                                        caption: "Product Department",
                                    }),
                                    construitTableau(result.stats.familyV, { caption: "Family" }),
                                    construitTableau(result.stats.couG, {
                                        caption: "Generic Color",
                                    }),
                                    construitTableau(result.stats.heel, { caption: "Heels" }),
                                    construitTableau(result.stats.desc, {
                                        caption: "Short Desc",
                                    }),
                                ],
                                triActuel: "",
                                choixChart: "qt",
                            };
                        },
                        components: { Doughnut },

                        methods: {
                            close() {
                                ModalHelper.hide();
                            },
                            toPrix(value, devise) {
                                return toPrix(value, devise);
                            },
                            pourcent(qt, totalQt) {
                                if (!totalQt) return " ";
                                return ((qt / totalQt) * 100).toFixed(0) + " %";
                            },

                            toChart(array) {
                                // https://vue-chartjs.org/examples/#vue-3-charts
                                let data = {
                                    labels: [],
                                    datasets: [
                                        {
                                            data: [],
                                            backgroundColor: colors,
                                        },
                                    ],
                                };

                                for (const item of array) {
                                    if (item[this.choixChart] > 0) {
                                        data.labels.push(item.v || item.key);

                                        data.datasets[0].data.push(item[this.choixChart]);
                                    }
                                }

                                return data;
                            },

                            tri(tableau, name) {
                                tableau.sens = this.triActuel == name ? -tableau.sens : 1;
                                if (name == "qt")
                                    tableau.rows.sort((a, b) => (b.qt - a.qt) * tableau.sens);
                                if (name == "ht")
                                    tableau.rows.sort((a, b) => (b.ht - a.ht) * tableau.sens);
                                if (name == "nb")
                                    tableau.rows.sort((a, b) => (b.nb - a.nb) * tableau.sens);
                                this.triActuel = name;
                                this.choixChart = name;
                            },
                        },

                        mounted() {
                            ModalHelper.show(async function () {
                                modaleApp.unmount();
                            });
                        },
                    });

                    modaleApp.mount(ModalHelper.html(orderChart).container);
                },
            },

            mounted() {
                const thisVue = this;
                Store.set("getCurrentOrder", async function () {
                    return await thisVue.getCurrentOrder();
                });
                Store.set("setCurrentorder", async function (_id) {
                    /* console.log(_id) */
                    await thisVue.changeOrder(_id);
                    //await thisVue._majOrder(_id);
                });
                Store.set("getOrderlist", async function (echangeur) {
                    return await thisVue.getOrderlist(echangeur);
                });
                // Lance select order
                Store.set("selectOrder", async function (callback) {
                    await thisVue.lanceSelectOrder(callback);
                });
                Store.set("creatOrder", async function (callback) {
                    await thisVue.lanceSelectOrder(callback, true);
                });
                Store.set("creatBulk", async function (callback) {
                    await thisVue.createOrder(callback, true);
                });
                Store.set("duplicateOrder", async function (callback, p) {
                    await thisVue.duplicateOrder(callback, p);
                });
                Store.set("updateTotaux", function (order) {
                    thisVue.updateTotaux(order);
                });
                Store.set("getData", function () {
                    return thisVue.getData();
                });
                Store.set("toggleTopbar", function (affiche) {
                    THIS.c$(".__topbar").toggle(affiche);
                });
            },
        });

        CONTEXTE.vm = app.mount(THIS.c$("._vueChargement")[0]);

        console.log("👗 orderManager.onLoad >> fin  ");


        //Store.on("topbar", async function (affiche) {
        //   THIS.c$('.__topbar').toggle(affiche);
        //});
    },
    getVm$Data: function () {
        return CONTEXTE.vm.$data;
    },
};

export default {
    orderManager: { js: orderManagerMf, html: orderManagerHtml },
};

function construitTableau(array, options) {
    const total = { qt: 0, ht: 0, nb: 0 };

    for (const item of array) {
        total.qt += item.qt;
        total.ht += item.ht;
        total.nb += item.nb;
    }

    const retour = Object.assign({}, options);
    retour.rows = array;
    retour.total = total;
    retour.tri = "";
    retour.sens = "";
    return retour;
}

const colors = [
    "#2196F3",
    "#E3F2FD",
    "#BBDEFB",
    "#90CAF9",
    "#64B5F6",
    "#42A5F5",
    "#1E88E5",
    "#1976D2",
    "#1565C0",
    "#0D47A1",
    "#3F51B5",
    "#E8EAF6",
    "#C5CAE9",
    "#9FA8DA",
    "#7986CB",
    "#5C6BC0",
    "#3949AB",
    "#303F9F",
    "#283593",
    "#1A237E",
];
